import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Переход из мастера на полный экран системы (Excel-загрузка, все реквизиты…).
 *
 * В режиме фокуса Layout возвращает администратора в мастер. Чтобы ссылка из
 * самого мастера не отскакивала назад, помечаем вкладку «вышел из мастера сам»
 * (sessionStorage) — Layout тогда показывает полоску «Вернуться к настройке».
 * Флаг снимается, когда мастер снова открыт.
 */
export const DETOUR_KEY = 'wms_setup_detour';

export function markDetour() {
  try { sessionStorage.setItem(DETOUR_KEY, '1'); } catch (e) { /* приватный режим */ }
}

export function clearDetour() {
  try { sessionStorage.removeItem(DETOUR_KEY); } catch (e) { /* приватный режим */ }
}

export function isDetour() {
  try { return sessionStorage.getItem(DETOUR_KEY) === '1'; } catch (e) { return false; }
}

// «Пропустить» / «Завершить» в этой вкладке — больше не уводим в мастер, даже если
// сервер ещё не успел ответить новым статусом (или старый сервер без /setup/skip)
const RELEASED_KEY = 'wms_setup_released';
export function markReleased() {
  try { sessionStorage.setItem(RELEASED_KEY, '1'); } catch (e) { /* приватный режим */ }
}
export function isReleased() {
  try { return sessionStorage.getItem(RELEASED_KEY) === '1'; } catch (e) { return false; }
}

/** «Выдать кабинет клиенту»: сразу вкладка «Пользователи» первого клиента, а не список/«Данные» */
export function cabinetLink(st) {
  const c = (st?.steps || []).find((s) => s.key === 'clients');
  const id = c?.facts?.first_id;
  return id ? `/companies/${id}?tab=users` : '/companies';
}

export function DetourLink({ to, children, className, ...rest }) {
  return (
    <Link to={to} className={className} state={{ fromSetup: true }} onClick={markDetour} {...rest}>
      {children}
    </Link>
  );
}
